import { gql } from '@apollo/client'

export const BOARD_TYPES_QUERY = gql`
  query BoardTypes {
    boardTypes
  }
`
